import { toast } from 'react-toastify';
import React, { useState } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { useTranslation } from 'react-i18next';
import BeatLoader from 'react-spinners/BeatLoader';
import Swal from 'sweetalert2'

import { getAllTimezones } from "countries-and-timezones"

import {
  Button, TextField, InputAdornment, Select, MenuItem,
  InputLabel, FormControl
} from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';

import Prompt from '../../../Shared/Prompt/Prompt';
import PromptWrapper from '../../../Shared/Prompt/Wrapper';
import PromptActions from '../../../Shared/Prompt/Actions';

import { colors, roles, toastTimerValue } from '../../../../Shared/utils';
import { update, checkPiceasoftInfo } from '../../../../Functions/admin';
import { useAppContext } from '../../../../Context/App/Provider';
import { useEventContext } from '../../../../Context/Event/Provider';
import { setLocationGridValues, decodeHTMLEntities } from '../../../../Functions/utils';

import '../../../SweetAlert.css'


export default function UpdateLocations({ groups, locations, setLocations, selectedLocation, setSelectedLocation, databV2, setDatabV2, owners }) {
  const { t } = useTranslation();
  const [{ user }, dispatch] = useAppContext();
  const [{ groupsLocationsStatus }, eventDispatch] = useEventContext();

  const [loading, setLoading] = useState(false);
  const [newLocation, setNewLocation] = useState({
    ...selectedLocation,
    oldName: selectedLocation.name,
    dbType: selectedLocation.dbType === 'SDS' ? 1 : 2,
    activityPc: selectedLocation.activityPc === t('global.yes') ? true : false,
    activityMobile: selectedLocation.activityMobile === t('global.yes') ? true : false
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showPiceasoftClientKey, setShowPiceasoftClientKey] = useState(false);

  const [checkPiceasoftInfoResult, setCheckPiceasoftInfoResult] = useState(undefined);
  const [checkPiceasoftInfoDetails, setCheckPiceasoftInfoDetails] = useState(undefined);

  const timeZones = getAllTimezones();
  // console.log("50 - timeZones=", timeZones);
  // console.log("51 - selectedLocation=", selectedLocation);

  const handleCheckPiceasoftInfo = (id, key, showMessage) => {
    // console.log("47 - id=", id);
    // console.log("48 - key=", key);

    setCheckPiceasoftInfoResult(undefined);

    checkPiceasoftInfo({ id, key }).then(res => {
      // console.log("53 - res=", res);

      if (res) {
        if (res.error !== undefined) {
          if (res.error !== null && res.error !== 0) {
            setCheckPiceasoftInfoResult(res && res.error);
            setCheckPiceasoftInfoDetails(res && res.details);

            if (showMessage) {
              return toast(decodeHTMLEntities
                (
                  t(`piceasoft_api_status_code.piceasoft_api_error`)
                  + ' : "'
                  + t(`piceasoft_api_status_code.${res.error}`) + '"'
                  + (res.details !== undefined ? ' (' + res.details + ')' : ""))
                , { type: 'error' }
              );
            }
          }
          else {
            setCheckPiceasoftInfoResult(0);
            setCheckPiceasoftInfoDetails(undefined);
          }
        }
        else
          setCheckPiceasoftInfoDetails(res && res.details);
      }
    });
  }


  const handleUpdateLocation = (e, location) => {
    e.preventDefault();
    setLoading(true);

    if (location.mobileProcess && location.piceasoftCheck) {
      handleCheckPiceasoftInfo(location.piceaApiId, location.piceaApiKey, true);
    }

    update({ type: 'location', location }).then(res => {
      setLoading(false);
      if (!res.success) {
        return toast(decodeHTMLEntities(t('admin.locations.errors.' + res, { name: location.label })), { type: 'error' });
      }

      // console.log("107 - res=", res);
      // console.log("109 - selectedLocation=", selectedLocation);

      const newLocations = locations.slice(); // .slice() creates a new array
      for (const [index, row] of newLocations.entries()) {
        if (row.id === res.location.id) {

          if (selectedLocation && selectedLocation.favoriteId)
            res.location.favoriteId = selectedLocation.favoriteId;

          if (selectedLocation && selectedLocation.last)
            res.location.last = selectedLocation.last;

          if (selectedLocation && selectedLocation.moduleVersion)
            res.location.moduleVersion = selectedLocation.moduleVersion;

          // if (location && location.email)
          //   res.location.email = location.email;

          newLocations[index] = setLocationGridValues(t, res.location, groups); break;
        }
      }

      // update default groups sorting in case of name change
      //setLocations(newLocations.sort((a, b) => a.label.localeCompare(b.label)));
      setLocations(newLocations.sort(function (a, b) {
        if (a.group && b.group && a.group.toLowerCase() < b.group.toLowerCase()) {
          return -1;
        }
        if (a.group && b.group && b.group.toLowerCase() < a.group.toLowerCase()) {
          return 1;
        }

        if (a.label && b.label && a.label.toLowerCase() < b.label.toLowerCase()) {
          return -1;
        }
        return 1;
      })
      );

      setSelectedLocation(null);
      toast(decodeHTMLEntities(t('admin.locations.update.success', { name: location.label })), { type: 'success' });

      setDatabV2({});
      // dispatch({ forceReload: true, forceReloadScenario: true });
      eventDispatch({ groupsLocationsStatus: 'pending' });
    });
  };

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleClickShowPiceasoftClientKey = () => setShowPiceasoftClientKey(!showPiceasoftClientKey);

  // console.log("112 - newLocation=", newLocation);
  // console.log("134 - selectedLocation=", selectedLocation);
  // console.log("135 - decodeHTMLEntities=", decodeHTMLEntities(selectedLocation.label));

  // OWNER options:
  let ownerOptions = [];
  for (const owner of owners) {
    let option = {
      id: owner.id,
      email: owner.email
    }
    ownerOptions.push(option);
  }

  return (
    <Prompt animated>
      <form className="prompt__container animated" onSubmit={e => handleUpdateLocation(e, newLocation)}>
        <PromptWrapper>
          <div className="prompt__title">
            <h1 title={selectedLocation.label}>
              {decodeHTMLEntities(t('admin.locations.update.title', { name: selectedLocation.label }))}
            </h1>
            {user.roleId <= roles.stAdmin && <div>
              <select
                className="singleSelect"
                required
                value={newLocation.groupId}
                title={t('admin.locations.columns.group')}
                onChange={e => setNewLocation({ ...newLocation, groupId: Number(e.target.value) })}
              >
                {groups.map(group => <option key={group.id} value={group.id}>{group.name}</option>)}
              </select>
            </div>}
          </div>

          <div className="prompt__content">
            <div className="flexRow" style={{ alignItems: 'flex-end' }}>
              <TextField
                InputProps={{
                  startAdornment: <InputAdornment position="start">
                    <span className="material-icons-outlined">description</span>
                  </InputAdornment>
                }}
                required
                variant="outlined"
                style={{ width: '75%' }}
                value={newLocation.label}
                label={t('admin.locations.columns.label')}
                onChange={e => setNewLocation({ ...newLocation, label: e.target.value })}
              />

              <div style={{ width: '25%' }}>
                <FormControl variant="outlined" style={{ width: '100%' }}>
                  <InputLabel>{t('admin.locations.columns.db_type')}</InputLabel>
                  <Select
                    value={Number(newLocation.dbType)}
                    label={t('admin.locations.columns.db_type')}
                    onChange={e => setNewLocation({ ...newLocation, dbType: e.target.value })}
                  >
                    <MenuItem value={1}>SDS</MenuItem>
                    <MenuItem value={2}>Kiosk</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>

            <div className="flexRow">
              {newLocation.exists ? (
              <TextField
                InputProps={{
                  startAdornment: <InputAdornment position="start">
                    <span className="material-icons-outlined">storage</span>
                  </InputAdornment>
                }}
                  disabled={newLocation.exists}
                required
                variant="outlined"
                value={newLocation.name}
                label={t('admin.locations.columns.name')}
                onChange={e => setNewLocation({ ...newLocation, name: e.target.value })}
              />
              ) : (

                <div style={{ width: '50%' }}>
                  <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                  // disabled
                  >
                    <InputLabel>
                      {t('admin.locations.columns.name')}
                    </InputLabel>
                    <Select
                      label={t('admin.locations.columns.name')}
                      value={newLocation.name}
                      onChange={e => {
                        setNewLocation({ ...newLocation, name: e.target.value })
                      }}
                    >
                      {(databV2.length > 0) ? (
                        databV2.map(bdd => <MenuItem key={bdd.id} value={bdd.name}>{bdd.name}</MenuItem>)
                      ) : (
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '8px 0' }}>
                          <BeatLoader color={colors.softthinks} />
                        </div>
                      )}
                    </Select>
                  </FormControl>
                </div>)
              }

              <TextField
                InputProps={{
                  startAdornment: <InputAdornment position="start">
                    <span className="material-icons-outlined">cloud</span>
                  </InputAdornment>,
                  endAdornment: <>
                    <span className="separation" style={{ margin: '12px', alignSelf: 'stretch' }} />
                    <input type="numeric" min="0" max="99999" placeholder="N/A" value={newLocation.port}
                      onChange={e => setNewLocation({ ...newLocation, port: e.target.value.slice(0, 5) })}
                    />
                  </>
                }}
                placeholder="N/A"
                variant="outlined"
                className="loc__port"
                value={newLocation.ip}
                onChange={e => setNewLocation({ ...newLocation, ip: e.target.value })}
                label={t('admin.locations.columns.ip') + ' | ' + t('admin.locations.columns.port')}
              />
            </div>

            <div className="flexRow">
              <TextField
                InputProps={{
                  startAdornment: <InputAdornment position="start">
                    <span className="material-icons-outlined">account_circle</span>
                  </InputAdornment>
                }}
                placeholder="N/A"
                // required
                disabled
                variant="outlined"
                label={t('login.field1')}
                value={newLocation.login}
                onChange={e => setNewLocation({ ...newLocation, login: e.target.value })}
              />

              <TextField
                InputProps={{
                  startAdornment: <InputAdornment position="start">
                    <span className="material-icons-outlined" onClick={e => {
                      if (user.roleId <= roles.stAdmin)
                        return handleClickShowPassword()
                    }}>
                      lock
                    </span>
                  </InputAdornment>
                }}
                type={ (!showPassword) ? "password" : " "}
                placeholder="N/A"
                // required
                disabled
                variant="outlined"
                autoComplete="off"
                name="loc-password"
                label={t('login.field2')}
                value={newLocation.password}
                onChange={e => setNewLocation({ ...newLocation, password: e.target.value })}
              />
            </div>

            <div className="flexRow">
              {/* <TextField
                InputProps={{
                  startAdornment: <InputAdornment position="start">
                    <span className="material-icons-outlined">place</span>
                  </InputAdornment>
                }}
                placeholder="N/A"
                variant="outlined"
                value={newLocation.mceLocation ?? ''}
                label={t('admin.locations.columns.mce_location')}
                onChange={e => setNewLocation({...newLocation, mceLocation: e.target.value || null})}
              /> */}

              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  inputVariant="outlined"
                  value={newLocation.deactivation}
                  InputAdornmentProps={{ position: 'start' }}
                  label={t('admin.locations.columns.deactivation')}
                  onChange={date => setNewLocation({
                    ...newLocation, // set date to null when date is cleared
                    deactivation: new Date(date).getTime() ? new Date(date.getTime() + Math.abs(date.getTimezoneOffset() * 60000)).toJSON().slice(0, 10) : null
                  })}
                  format={localStorage.getItem('lang') === 'fr' ? 'dd/MM/yyyy' : 'MM/dd/yyyy'}
                  placeholder={localStorage.getItem('lang') === 'fr' ? 'jj/mm/aaaa' : 'mm/dd/yyyy'}
                  style={{ width: '100%' }}
                />
              </MuiPickersUtilsProvider>

              <div style={{ width: '100%' }}>
                <FormControl variant="outlined" style={{ width: '100%' }}>
                  <InputLabel>{t('admin.locations.columns.status')}</InputLabel>
                  <Select
                    value={newLocation.status}
                    label={t('admin.locations.columns.status')}
                    onChange={e => setNewLocation({ ...newLocation, status: e.target.value })}
                  >
                    <MenuItem value={'production'}>{t('admin.locations.status.production')}</MenuItem>
                    <MenuItem value={'pilot'}>{t('admin.locations.status.pilot')}</MenuItem>
                    <MenuItem value={'internal'}>{t('admin.locations.status.internal')}</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>

            <div className="flexRow">
              <FormControl variant="outlined" style={{ width: '100%' }}>
                <InputLabel>{t('admin.locations.columns.timezone')}</InputLabel>
                <Select
                  value={newLocation.timezone}
                  label={t('admin.locations.columns.timezone')}
                  onChange={e => setNewLocation({ ...newLocation, timezone: e.target.value })}
                >
                  {Object.entries(timeZones).sort(function (a, b) {
                    if (a[1].utcOffset < b[1].utcOffset) {
                      return -1;
                    }
                    if (a[1].utcOffset > b[1].utcOffset) {
                      return 1;
                    }
                    return 0;
                  }).map(tz => {
                    return (
                      <MenuItem
                        key={tz[1].name}
                        value={tz[0]}
                      >
                        {"(GMT" + tz[1].utcOffsetStr + ")  " + tz[1].name}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>

              <div style={{ width: '33%' }}>
                <FormControl variant="outlined" style={{ width: '100%' }}>
                  <InputLabel>{t('admin.locations.columns.creator')}</InputLabel>
                  <Select
                    label={t('admin.locations.columns.creator')} value={newLocation.owner}
                    onChange={e => {
                      const ownerTmp = owners.find((element) => {
                        return element.id === e.target.value;
                      });
                      return setNewLocation({ ...newLocation, owner: e.target.value, email: ownerTmp.email })
                    }}
                  >
                    {ownerOptions.map(owner => <MenuItem value={owner.id}>{owner.email}</MenuItem>)}
                  </Select>
                </FormControl>
              </div>
            </div>

            {/* mobileProcess */}
            <div className="checkbox action">
              <input
                disabled={false}
                id="mobileProcess"
                type="checkbox"
                defaultChecked={newLocation.mobileProcess}
                onChange={e => {
                  setNewLocation({ ...newLocation, mobileProcess: !newLocation.mobileProcess })
                }}
              />
              <label htmlFor="mobileProcessing">{t('admin.locations.create.mobileProcessing')}</label>
            </div>

              {newLocation.mobileProcess && (
                <div className="checkbox action">
                  <input
                    disabled={false}
                    id="mobileProcess"
                    type="checkbox"
                    defaultChecked={newLocation.piceasoftCheck}
                    onChange={e => {
                      setNewLocation({ ...newLocation, piceasoftCheck: !newLocation.piceasoftCheck })
                    }}
                  />
                  <label htmlFor="piceasoftCheck">{t('admin.locations.create.piceasoftCheck')}</label>

                <span style={{ paddingLeft: '180px' }}>
                  <Button
                    className="button"
                    onClick={() => handleCheckPiceasoftInfo(newLocation.piceaApiId, newLocation.piceaApiKey, false)}
                    title={
                      (checkPiceasoftInfoResult !== undefined && checkPiceasoftInfoResult !== 0) ? (
                        t(`piceasoft_api_status_code.piceasoft_api_error`)
                        + ' : "'
                        + t(`piceasoft_api_status_code.${checkPiceasoftInfoResult}`) + '"'
                        + (checkPiceasoftInfoDetails !== undefined ? ' (' + checkPiceasoftInfoDetails + ')' : "")) : t('admin.locations.create.check_connection')
                    }
                    style={{ color: (checkPiceasoftInfoResult === undefined ? 'gray' : (checkPiceasoftInfoResult !== 0 ? "Red" : "Green")) }}
                  >
                    <span
                      className="material-icons-round"
                      style={{ color: (checkPiceasoftInfoResult === undefined ? 'gray' : (checkPiceasoftInfoResult !== 0 ? "Red" : "Green")) }}
                    >
                      check_circle_outlined
                    </span>
                    {t('admin.locations.create.check_connection')}
                  </Button>
                </span>
                </div>
              )}

              {newLocation.mobileProcess && newLocation.piceasoftCheck && (
                <TextField 
                  InputProps={{}}
                  placeholder="N/A"
                  variant="outlined"
                  label={t('admin.locations.create.piceasoftClientId')}
                  value={newLocation.piceaApiId}
                  onChange={e => setNewLocation({ ...newLocation, piceaApiId: e.target.value })}
                />
              )}

              {newLocation.mobileProcess && newLocation.piceasoftCheck && (
                <TextField
                  InputProps={{
                    startAdornment: <InputAdornment position="start">
                      <span className="material-icons-outlined" onClick={e => {
                        if (user.roleId <= roles.stAdmin)
                          return handleClickShowPiceasoftClientKey()
                      }}>
                        lock
                      </span>
                    </InputAdornment>
                  }}
                  type={(!showPiceasoftClientKey) ? "password" : " "}
                  placeholder="N/A"
                  // required
                  //disabled={newLocation.piceasoftCheck}
                  variant="outlined"
                  autoComplete="off"
                  name="piceasoft-clientkey"
                  label={t('admin.locations.create.piceasoftClientKey')}
                  value={newLocation.piceaApiKey}
                  onChange={e => setNewLocation({ ...newLocation, piceaApiKey: e.target.value })}
                />
              )}

          </div>
        </PromptWrapper>

        <PromptActions>
          <Button className="btnSecondary" onClick={() => setSelectedLocation(null)}>
            {t('global.cancel')}
          </Button>

          <Button className="btnPrimary" type="submit" disabled={loading}>
            {loading ? <BeatLoader color="white" css="transform:translateY(4px)" /> : t('global.update')}
          </Button>
        </PromptActions>
      </form>
    </Prompt>
  );
}
